import { useContext } from 'react';
import { ObjectContext } from '../context/ObjectContext';
export const useGetAdditionalPropertyValue = () => useContext(ObjectContext).getAdditionalPropertyValue;